// eslint-disable-next-line no-restricted-imports
import styled from '@emotion/styled';
import {
  ChevronLeftIcon,
  Flex,
  SearchField,
  Typography,
} from '@iheartjane/reefer';
import { useMemo, useState } from 'react';

import { StoreSection } from '@jane/business-admin/components/premium/StoreSection';
import { useFetchCurrentBloomMenu } from '@jane/business-admin/data-access';
import { businessPaths } from '@jane/business-admin/util';
import { useNavigateBack } from '@jane/shared/hooks';

const StyledContainer = styled(Flex)(() => ({
  borderRadius: 24,
  marginTop: 60,
  marginBottom: 120,
  boxShadow: `0px 2px 16px 0px rgba(0, 0, 0, 0.05)`,
  overflow: 'hidden',
}));

export const PremiumStores = () => {
  const goBack = useNavigateBack(businessPaths.premium());

  const { data: bloomMenu } = useFetchCurrentBloomMenu();
  const stores = bloomMenu?.stores ?? [];

  const [searchFilter, setSearchFilter] = useState('');

  const filteredStores = useMemo(() => {
    if (!searchFilter) return stores;

    const lowerCaseSearch = searchFilter.toLowerCase();
    return stores.filter(
      (store) =>
        store.name.toLowerCase().includes(lowerCaseSearch) ||
        store.city?.toLowerCase().includes(lowerCaseSearch) ||
        String(store.id) === searchFilter
    );
  }, [stores, searchFilter]);

  return (
    <StyledContainer
      pt={40}
      pb={40}
      width="848px"
      mx="auto"
      flexDirection="column"
    >
      <Flex flexDirection="column" ml={24} mr={24}>
        <Flex
          gap={16}
          flexDirection="row"
          alignItems="center"
          alignContent="center"
        >
          <ChevronLeftIcon onClick={() => goBack()} altText="Go back" />
          <Typography variant="header-bold" branded>
            My stores
          </Typography>
        </Flex>
        <Flex mt={24} mb={16}>
          <SearchField
            label="Search stores"
            labelHidden
            name="store_search"
            placeholder="Search name, city or id"
            onChange={(value) => setSearchFilter(value)}
            isDebounced
            debounceDelay={300}
            width="100%"
          />
        </Flex>
      </Flex>
      {filteredStores.map((store) => (
        <StoreSection
          key={store.id}
          store={store}
          menuUrl={bloomMenu?.menu_url ?? ''}
          storeSlugs={bloomMenu?.store_slugs}
        />
      ))}
    </StyledContainer>
  );
};
